module.exports = __webpack_public_path__ + "static/media/report.1a975dc5.png";